"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPANY_OPTIONS = exports.COMPANY_NAMES = void 0;
exports.getCompanyName = getCompanyName;
exports.getCompanyOptions = getCompanyOptions;
var COMPANY_NAMES = exports.COMPANY_NAMES = ['', '南京瀚星', '南京瀚马', '上海瀚宝', '重庆瀚兴', '南京瀚林', '安吉虎跃', '贝思倍健', '安吉好味'];
var COMPANY_OPTIONS = exports.COMPANY_OPTIONS = COMPANY_NAMES.slice(1).map(function (name, index) {
  return {
    name: name,
    id: index + 1
  };
});
function getCompanyOptions() {
  return COMPANY_OPTIONS;
}
function getCompanyName(subject) {
  var emptyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (subject === 0 || subject === '0') {
    return emptyValue;
  }
  return COMPANY_NAMES[subject];
}